import { Injectable } from "@angular/core";
import { ApiResourceService } from "../../apiResource/apiResource.service";
import { Observable, forkJoin } from "rxjs";
import { ISamAgent } from "./ISamAgent";
import { ISamCompany } from "./ISamCompany";

@Injectable({
    providedIn: 'root'
})
export class SamResourceService {
    constructor(private readonly apiResourceService: ApiResourceService) { }

    public getAgent(id: number): Observable<ISamAgent> {
        return this.apiResourceService.getOne<ISamAgent>(
            this.apiResourceService.getApiUrl('sam', 'contacts', id),
            {}
        );
    }

    public getCompany(id: number): Observable<ISamCompany> {
        return this.apiResourceService.getOne<ISamCompany>(
            this.apiResourceService.getApiUrl('sam', 'companies', id),
            {}
        );
    }

    public getAgentByLogin(login: string): Observable<ISamAgent> {
        return this.apiResourceService.getOne<ISamAgent>(
            this.apiResourceService.getApiUrl('sam', 'contacts', login),
            {}
        );
    }

    public getAgentAndCompany(agentId: number, companyId: number): Observable<[ISamAgent, ISamCompany]> {
        return forkJoin([
            this.getAgent(agentId),
            this.getCompany(companyId),
        ]);
    }
}